import type { CurrentWorkspace } from '@/app/WorkspaceContext';

export interface Required {
  project: boolean;
  task: boolean;
  tag: boolean;
  description: boolean;
}

/** Pflichtfelder laut Workspace-Einstellung (TT-08), nur wenn das Feature freigeschaltet ist. */
export function requiredFields(ctx: CurrentWorkspace): Required {
  if (!ctx.hasFeature('REQUIRED_FIELDS')) {
    return { project: false, task: false, tag: false, description: false };
  }
  const r = ctx.workspace.settings.tracking;
  return { project: r.requireProject, task: r.requireTask, tag: r.requireTag, description: r.requireDescription };
}
